export default "__VITE_ASSET__BYr_338r__"